import React, { useEffect, useState } from 'react';
import { ImNewTab } from 'react-icons/im';
import { RxCrossCircled } from 'react-icons/rx';
import { IoIosCheckmarkCircleOutline } from 'react-icons/io';
import toast from 'react-hot-toast';
import { ColoredCheckSquareIcon } from 'ui-component/custom-icons/icons';
import { Skeleton, Tooltip, Avatar } from '@mui/material';

// ✅ Clear
const DetailModalMobile = ({ isOpen, onClose, selectedId, isApproved, onRemove, onApprove }) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!isOpen) return;
        api.getClientGeneralInformation(selectedId).then((res) => {
            setData(res.data);
            setIsLoading(false);

			res.data.client === null ||
			res.data.companyBillingAddress === null ||
			res.data.companyContact === null ||
			res.data.companyDoc === null ||
			res.data.companyInfo === null ||
			res.data.companyShippingAddress === null
        });
    }, [selectedId, isOpen]);

    const companyActivity = data?.dropdowns?.find((dropdown) => dropdown.type === 'Company Activity')?.name;
    const companyTurnover = data?.dropdowns?.find((dropdown) => dropdown.type === 'Company Turnover')?.name;

    const approveContact = (id) => {
        api
            .approveClients(id)
            .then(() => {
                toast.success('Contact Approved Successfully');
                api.getallClients().then(() => {
                    onClose();
					// onRemove(id)
					onApprove(id)
                });
            })
            .catch(() => {
                toast.error('Failed to Approve Contact');
            });
    };

    const rejectContact = (id) => {
        api
            .rejectClients(id)
            .then(() => {
                toast.success('Contact Rejected Successfully');
                api.getallClients().then(() => {
                    onClose();
					onRemove(id)
                });
            })
            .catch(() => {
                toast.error('Failed to Reject Contact');
            });
    };


    return (
		<div
			style={{
				width: '100vw',
				height: '100dvh',
				position: 'fixed',
				left: 0,
				top: 0,
				zIndex: 30,
				background: 'rgba(0,0,0,0.07)',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'flex-end',
				alignItems: 'center',
				paddingBottom: '90px',
				backdropFilter: 'blur(8px)',
				WebkitBackdropFilter: 'blur(8px)'
			}}
		>
			<div
				className="popup product-popup-mobile d-md-none"
				style={{
					position: 'relative',
					transform: 'none',
					top: 0,
					left: 0,
					maxWidth: '90%',
					background: '#fff',
					borderRadius: 12,
					boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
					width: '100%',
					minHeight: '70dvh',
					maxHeight: '80dvh',
					padding: '24px 16px 0 16px',
					display: 'flex',
					flexDirection: 'column'
				}}
			>
				{/* Header */}
				<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
					<h4 style={{ margin: 0, fontWeight: 600, fontSize: 18 }}>Client Details</h4>
				</div>
				<div style={{ overflowY: 'auto', flex: 1, paddingBottom: 20, scrollbarWidth: 'thin', scrollbarColor: 'transparent transparent' }}>
					{/* Company Info */}
					<Section title="Company Info">
						{
							isLoading ? (
								<div className="w-full" style={{ marginBottom: '10px'}}>
									<div style={{ width: '150px', marginBottom: '8px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
									</div>
									<div>
										<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
									</div>
								</div>
							) : (
								<InputRow label="First Name" value={data?.client?.first_name} />
							)
						}
						{
							isLoading ? (
								<div className="w-full" style={{ marginBottom: '10px'}}>
									<div style={{ width: '150px', marginBottom: '8px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
									</div>
									<div>
										<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
									</div>
								</div>
							) : (
								<InputRow label="Last Name" value={data?.client?.last_name} />
							)
						}
						{
							isLoading ? (
								<div className="w-full" style={{ marginBottom: '10px'}}>
									<div style={{ width: '150px', marginBottom: '8px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
									</div>
									<div>
										<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
									</div>
								</div>
							) : (
								<InputRow label="Phone Number" value={data?.client?.number} />
							)
						}
						{
							isLoading ? (
								<div className="w-full" style={{ marginBottom: '10px'}}>
									<div style={{ width: '150px', marginBottom: '8px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
									</div>
									<div>
										<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
									</div>
								</div>
							) : (
								<InputRow label="Company Name" value={data?.client?.company_name} />
							)
						}
						{
							isLoading ? (
								<div className="w-full" style={{ marginBottom: '10px'}}>
									<div style={{ width: '150px', marginBottom: '8px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
									</div>
									<div>
										<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
									</div>
								</div>
							) : (
								<InputRow label="Establishment Year" value={data?.companyInfo?.establishment_year} />
							)
						}
						{
							isLoading ? (
								<div className="w-full" style={{ marginBottom: '10px'}}>
									<div style={{ width: '150px', marginBottom: '8px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
									</div>
									<div>
										<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
									</div>
								</div>
							) : (
								<InputRow label="Activities" value={companyActivity} />
							)
						}
						{
							isLoading ? (
								<div className="w-full" style={{ marginBottom: '10px'}}>
									<div style={{ width: '150px', marginBottom: '8px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
									</div>
									<div>
										<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
									</div>
								</div>
							) : (
								<InputRow label="Annual Turnover" value={companyTurnover} />
							)
						}
						
					</Section>
					{/* Contacts */}
					<Section title="Contacts">
						{
							isLoading ? (
								[...Array(5)].map((e, i) => (
									<div className="w-full" style={{ marginBottom: '10px'}}>
										<div style={{ width: '150px', marginBottom: '8px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
										</div>
										<div>
											<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
										</div>
									</div>
								))
							) : (
								data?.companyContact?.contact_person ||
								data?.companyContact?.email ||
								data?.companyContact?.website ||
								data?.companyContact?.phone_number ||
								data?.companyContact?.whatsapp ?
								(
									<>
										<InputRow label="Sales Contact" value={data?.companyContact?.contact_person} />
										<InputRow label="Company Email" value={data?.companyContact?.email} />
										<InputRow label="Website" value={data?.companyContact?.website} />
										<InputRow
											label="Phone Number"
											value={
												data?.companyContact?.phone_number ? `${data?.companyContact?.phone_code}${data?.companyContact?.phone_number}` : ''
											}
										/>
										<InputRow
											label="WhatsApp Number"
											value={data?.companyContact?.whatsapp ? `${data?.companyContact?.whatsapp_code}${data?.companyContact?.whatsapp}` : ''}
										/>
									</>
								) : (
									<div className="contacts-approval-no-data" style={{ color: '#888', fontSize: 14, marginBottom: 10 }}>
										No information available
									</div>
								)
							)
						}
					</Section>
					{/* Billing Address */}
					<Section title="Billing Address">
						{
							isLoading ? (
								[...Array(4)].map((e, i) => (
									<div className="w-full" style={{ marginBottom: '10px'}}>
										<div style={{ width: '150px', marginBottom: '8px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />	
										</div>
										<div>
											<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
										</div>
									</div>
								))
							) : (
								data?.companyBillingAddress?.address ||
								data?.companyBillingAddress?.city ||
								data?.companyBillingAddress?.zip ||
								data?.companyBillingAddress?.country ?
								(
									<>
										<InputRow label="Address" value={data?.companyBillingAddress?.address} />
										<InputRow label="City" value={data?.companyBillingAddress?.city} />
										<InputRow label="Zip Code" value={data?.companyBillingAddress?.zip} />
										<InputRow label="Country" value={data?.companyBillingAddress?.country} />
									</>
								) : (
									<div className="contacts-approval-no-data" style={{ color: '#888', fontSize: 14, marginBottom: 10 }}>
										No available billing address
									</div>
								)
							)
						}
					</Section>
					{/* Shipping Address */}
					<Section title="Shipping Address">
						{
							isLoading ? (
								[...Array(4)].map((e, i) => (
									<div className="w-full" style={{ marginBottom: '10px'}}>
										<div style={{ width: '150px', marginBottom: '8px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
										</div>
										<div>
											<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
										</div>
									</div>
								))
							) : (
								data?.companyShippingAddress?.address ||
								data?.companyShippingAddress?.city ||
								data?.companyShippingAddress?.zip ||
								data?.companyShippingAddress?.country ?
								(
									<>
										<InputRow label="Address" value={data?.companyShippingAddress?.address} />
										<InputRow label="City" value={data?.companyShippingAddress?.city} />
										<InputRow label="Zip Code" value={data?.companyShippingAddress?.zip} />
										<InputRow label="Country" value={data?.companyShippingAddress?.country} />
									</>
								) : (
									<div className="contacts-approval-no-data" style={{ color: '#888', fontSize: 14, marginBottom: 10 }}>
										No available shipping address
									</div>
								)
							)
						}
					</Section>
					{/* Documents */}
					<Section title="Documents">
						{
							isLoading ? (
								<>
									<div className="w-full" style={{ marginBottom: '10px'}}>
										<div style={{ width: '150px', marginBottom: '8px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
										</div>
										<div>
											<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
										</div>
									</div>
									<div className="w-full" style={{ marginBottom: '10px'}}>
										<div style={{ width: '150px', marginBottom: '8px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
										</div>
										<div>
											<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
										</div>
									</div>
								</>
							) : (
								data?.companyDoc?.vat_code || data?.companyDoc?.registration_number ? (
									<>
										<div style={{ marginBottom: 10 }}>
											<label style={{ color: '#595959', fontWeight: 500, marginBottom: 3, display: 'block' }}>
												<span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
													VAT code
													{data?.companyDoc?.is_vat_applicable === 'Not Applicable' && (
														<Tooltip title="Not Applicable" arrow placement="top">
															<span>
																<ColoredCheckSquareIcon height="15px" width="15px" />
															</span>
														</Tooltip>
													)}
												</span>
											</label>
											<input
												type="text"
												className="form-control"
												value={data?.companyDoc?.vat_code || '--- N/A ---'}
												disabled
												style={{ color: data?.companyDoc?.vat_code ? '#222' : '#707070' }}
											/>
										</div>
										<InputRow label="Registration Number" value={data?.companyDoc?.registration_number} />
									</>
								) : (
									<div className="contacts-approval-no-data" style={{ color: '#888', fontSize: 14, marginBottom: 10 }}>
										No available documents
									</div>
								)
							)
						}
						{/* Attachments */}
						<div style={{ marginTop: 18 }}>
							<h5 style={{ fontWeight: 600, marginBottom: 10 }}>Attachment</h5>
						
							{
								isLoading ? (
									[...Array(3)].map((e, i) => (
										<div className="w-full" style={{ marginBottom: '10px'}}>
											<div style={{ width: '150px', marginBottom: '8px' }}>
												<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
											</div>
											<div>
												<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
											</div>
										</div>
									))
								) : (
									data?.companyDoc?.vat_doc_url || data?.companyDoc?.registration_doc_url || data?.companyDoc?.company_logo_url ? (
										<>
											<AttachmentInputRow
												label="VAT File"
												url={data?.companyDoc?.vat_doc_url}
												file={data?.companyDoc?.vat_doc}
												isVatNotApplicable={data?.companyDoc?.is_vat_applicable === 'Not Applicable'}
											/>
											<AttachmentInputRow
												label="Registration File"
												url={data?.companyDoc?.registration_doc_url}
												file={data?.companyDoc?.registration_doc}
											/>
											<AttachmentInputRow
												label="Company Logo"
												url={data?.companyDoc?.company_logo_url}
												file={data?.companyDoc?.company_logo}
											/>
										</>
									) : (
										<div className="contacts-approval-no-data" style={{ color: '#888', fontSize: 14, marginBottom: 10 }}>
											No available attachment
										</div>
									)
								)
							}


						</div>
					</Section>
					{/* Bank Details */}
					<Section title="Bank Details">
						{
							isLoading ? (
								[...Array(5)].map((e, i) => (
									<div className="w-full" style={{ marginBottom: '10px'}}>
										<div style={{ width: '150px', marginBottom: '8px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
										</div>
										<div>
											<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
										</div>
									</div>
								))
							) : (
								data?.companyBank?.bank_name ||
								data?.companyBank?.bank_beneficiary_name ||
								data?.companyBank?.bank_IBAN ||
								data?.companyBank?.bank_SWIFT ||
								data?.companyBank?.bank_address ? (
									<>
										<InputRow label="Bank Name" value={data?.companyBank?.bank_name} />
										<InputRow label="Bank Beneficiary" value={data?.companyBank?.bank_beneficiary_name} />
										<InputRow label="Bank IBAN" value={data?.companyBank?.bank_IBAN} />
										<InputRow label="Bank SWIFT" value={data?.companyBank?.bank_SWIFT} />
										<InputRow label="Address" value={data?.companyBank?.bank_address} />
									</>
								) : (
									<div className="contacts-approval-no-data" style={{ color: '#888', fontSize: 14, marginBottom: 10 }}>
										No available bank details
									</div>
								)
							)
						}
					</Section>
					{/* Interests */}
					<Section title="Interests">
						{
							isLoading ? (
								<div className="w-full flex gap-3" style={{ marginBottom: '10px'}}>
									{[...Array(2)].map((e, i) => (
										<>
											<div style={{ width: '120px', marginBottom: '8px' }}>
												<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
											</div>
											<div>
												<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
											</div>
										</>
									))}
								</div>
							) : (
								data?.interests?.length > 0 ? (
									<div className="popup-small-card-tag-container" style={{ marginBottom: 10 }}>
										{data?.interests?.map((interest, index) => (
											<div className="popup-small-card-tag-content" key={index}>
												{interest?.name}
											</div>
										))}
									</div>
								) : (
									<div className="contacts-approval-no-data" style={{ color: '#888', fontSize: 14, marginBottom: 10 }}>
										No available interests
									</div>
								)
							)
						}
					</Section>
					{/* Specifications */}
					<Section title="Specifications">
						{
							isLoading ? (
								<div className="w-full flex gap-3" style={{ marginBottom: '10px'}}>
									{[...Array(2)].map((e, i) => (
										<>
											<div style={{ width: '120px', marginBottom: '8px' }}>
												<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
											</div>
											<div>
												<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
											</div>
										</>
									))}
								</div>
							) : (
								data?.specifications?.length > 0 ? (
									<div className="popup-small-card-tag-container" style={{ marginBottom: 10 }}>
										{data?.specifications?.map((specification, index) => (
											<div className="popup-small-card-tag-content" key={index}>
												{specification?.name}
											</div>
										))}
									</div>
								) : (
									<div className="contacts-approval-no-data" style={{ color: '#888', fontSize: 14, marginBottom: 10 }}>
										No available specifications
									</div>
								)
							)
						}
					</Section>
				</div>
				{/* Sticky bottom buttons */}
				<div
					style={{
						width: '100%',
						background: '#fff',
						padding: '16px 0 12px 0',
						zIndex: 30,
						display: 'flex',
						gap: 10,
						justifyContent: 'center',
						marginTop: 'auto',
						position: 'sticky',
						bottom: 0,
						left: 0
					}}
				>
						{
							isLoading ? (
								<>
									<div style={{ width: '110px' }}>
										<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
									</div>
									<div style={{ width: '110px' }}>
										<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
									</div>
									<div style={{ width: '110px' }}>
										<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '12px' }} />
									</div>
								</>
							) : (
								<>
									<button className="btn btn-light" style={{ border: '1px solid #ddd', color: '#222', minWidth: 80 }} onClick={onClose}>
										Close
									</button>
									{isApproved != 2 && (
										<>
											<button className="btn btn-primary btn-outlined-reject" onClick={() => rejectContact(data?.client.id)}>
												Reject <RxCrossCircled size={20} />
											</button>
											<button
												className="btn btn-primary btn-outlined-main"
												// disabled={isMissing}
												onClick={() => approveContact(data?.client.id)}
											>
												Approve <IoIosCheckmarkCircleOutline size={20} />
											</button>
										</>
									)}
								</>
							)
						}
				</div>
			</div>
		</div>
	);
};

// Section helper
const Section = ({ title, children }) => (
    <div style={{ marginBottom: 18 }}>
        <h5 style={{ fontWeight: 600, marginBottom: 10 }}>{title}</h5>
        {children}
    </div>
);

// Input row helper
const InputRow = ({ label, value }) => (
    <div style={{ marginBottom: 10 }}>
        <label style={{ color: '#595959', fontWeight: 500, marginBottom: 3, display: 'block' }}>{label}</label>
        <input
            type="text"
            className="form-control"
            value={value || '--- N/A ---'}
            disabled
            style={{ color: value ? '#222' : '#707070' }}
        />
    </div>
);

// Attachment input row helper
const AttachmentInputRow = ({ label, url, file, isVatNotApplicable }) => (
    <div style={{ marginBottom: 10 }}>
        <label style={{ color: '#595959', fontWeight: 500, marginBottom: 3, display: 'block' }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                {label}
                {isVatNotApplicable && (
                    <Tooltip title="Not Applicable" arrow placement="top">
                        <span>
                            <ColoredCheckSquareIcon height="15px" width="15px" />
                        </span>
                    </Tooltip>
                )}
            </span>
        </label>
        {url ? (
            <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'inherit', textDecoration: 'none' }}
            >
                <div className="attachments-file-client" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    {file ? file.split('/').pop().substring(0, 25) : 'View'}
                    <ImNewTab size={18} />
                </div>
            </a>
        ) : (
            <input
                type="text"
                className="form-control"
                value="--- N/A ---"
                disabled
                style={{ color: '#707070' }}
            />
        )}
    </div>
);

export default DetailModalMobile;